<template>
  <div>
    <form @submit.prevent="submit">
      <!-- LOGIN FIELDS -->
       <div v-if="loginMode == 'mf'">
        Only available for individual mathsframe users. For school users pelase <ContactLink />
       </div>
      <div v-if="screen == 'login' || screen == 'loggedin'">
        <div>
          <div class="sf-form-group">
            <label> Username* </label>
            <div class="tw-flex">
              <div v-if="loginMode == 'sf'" class="tw-w-32">
                <FormInput
                  v-model="loginFormData.fields.username_a"
                  class-name="sf-username-a"
                >
                  <input
                    type="text"
                    v-model="loginFormData.fields.username_a.value"
                    ref="usernameA"
                    name="username_a"
                    @change="onUsernameAChange"
                    @input="onUsernameAInput"
                    class="sf-form-control tw-w-full"
                  />
                </FormInput>
              </div>
              <div v-if="loginMode == 'sf'">
                <div class="tw-px-2 tw-py-3 tw-text-xl tw-font-bold">-</div>
              </div>
              <div class="tw-flex-grow">
                <FormInput
                  v-model="loginFormData.fields.username_b"
                  class-name="sf-username-b"
                >
                  <input
                    type="text"
                    v-model="loginFormData.fields.username_b.value"
                    ref="usernameB"
                    name="username_b"
                    class="sf-form-control tw-w-full"
                  />
                </FormInput>
              </div>
            </div>
          </div>
          <FormInput v-model="loginFormData.fields.password">
            <label> Password* </label>
            <input
              type="password"
              v-model="loginFormData.fields.password.value"
              name="password"
              class="sf-form-control tw-w-full"
              autocomplete="off"
            />
          </FormInput>
        </div>
        <!-- loggedin screen -->
        <div
          v-if="screen == 'loggedin'"
          class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full"
        >
          <div
            class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-mainbg1 tw-opacity-[0.75]"
          ></div>
          <div
            class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-text-primary"
          >
            <div class="tw-text-center">
              <div>Successful login</div>
              <div>Redirecting to the dashboard</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Forgot Fields -->
      <div v-else-if="screen == 'forgot'">
        <FormInput v-model="forgotFormData.fields.email">
          <label> Email* </label>
          <input
            type="text"
            v-model="forgotFormData.fields.email.value"
            ref="email"
            class="sf-form-control tw-w-full"
          />
        </FormInput>
      </div>
      <div v-else-if="screen == 'sent'" class="tw-mb-4">
        If there is an account registered under this addres an email will be 
        sent soon with instructions to reset your password
      </div>
      <!-- Error Message -->
      <div class="tw-relative tw-top-0 tw-left-0">
        <div
          class="tw-text-danger tw-absolute tw-top-0 tw-right-0 tw-left-[150px] tw-text-center"
        >
          <div v-if="errorName == 'connectionLimit'">
            You are logged on on another device or browser. You need to log off
            or wait 20 minutes to log on again.
          </div>
          <div v-else-if="errorName == 'loginInvalid'">
            Wrong username / password.
          </div>
          <div v-else>&nbsp;</div>
        </div>
      </div>
      <!-- Submit Buttons -->
      <div>
        <button v-if="screen != 'sent'" type="submit" class="sf-btn-primary">
          {{ submitLabel }}
        </button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { SfFormData, SfLoginScreen } from "@/types/generalTypes";
import FormInput from "../ui/FormInput.vue";
import submitForm from "@/func/form/submitForm";
import { PropType } from "vue";
import ContactLink from "../ui/ContactLink.vue";

export default defineComponent({
  components: { FormInput, ContactLink },
  props: {
    screen: { type: String as PropType<SfLoginScreen> },
    loginMode: { type: String, default: "sf" },
  },
  emits: ["closed", "switchscreen", "loggedin"],
  data() {
    return {
      showModal: true,
      failed: false,
      errorName: null as string | null,
      loginFormData: {
        fields: {
          username_a: { value: "", required: true },
          username_b: { value: "", required: true },
          password: { value: "", required: true },
          mode: { value: "" },
        },
      } as SfFormData,
      forgotFormData: {
        fields: {
          email: { value: "", required: true, isEmail: true },
        },
      } as SfFormData,
      timer: 0,
    };
  },
  computed: {
    submitLabel(): string {
      switch (this.screen) {
        case "login":
          return "Login";
        case "forgot":
          return "Send Reminder";
      }
      return "Send";
    },
  },
  mounted() {
    this.timer = setTimeout(() => this.focusField(), 500);
  },
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    focusField() {
      switch (this.screen) {
        case "login":
          (this.$refs.usernameA as HTMLElement).focus();
          break;
        case "forgot":
          (this.$refs.email as HTMLElement).focus();
          break;
      }
      this.timer = 0;
    },
    onUsernameAChange() {
      if (this.loginMode == "sf") {
        const parts = this.loginFormData.fields.username_a.value.split("-");
        if (parts.length > 1) {
          this.loginFormData.fields.username_a.value = parts[0].trim();
          this.loginFormData.fields.username_b.value = parts[1].trim();
        }
      }
    },
    onUsernameAInput(e: any) {
      if (this.loginMode == "sf") {
        const parts = e.target.value.split("-");
        if (parts.length > 1) {
          this.loginFormData.fields.username_a.value = parts[0].trim();
          if (this.loginFormData.fields.username_b.value.length < 1) {
            this.loginFormData.fields.username_b.value = parts[1].trim();
          }
          (this.$refs.usernameB as HTMLInputElement).focus();
        }
      }
    },
    submit() {
      if (this.screen == "login") {
        this.loginFormData.fields.username_a.required = this.loginMode == "sf";
        this.loginFormData.fields.mode.value = this.loginMode;
        this.submitData(
          "auth/login",
          this.loginFormData,
          "loggedin"
        );
      } else if (this.screen == "forgot") {
        this.submitData("auth/reset-password", this.forgotFormData, "sent");
      }
    },
    async submitData(
      url: string,
      data: SfFormData,
      next: SfLoginScreen,
    ) {
      this.errorName = null;
      this.failed = false;
      const resData = await submitForm(url, data);
      if (this.screen == "login") {
        this.loginFormData = resData.formData;
      } else {
        this.forgotFormData = resData.formData;
      }
      if (resData.response.success) {
        if (next) {
          this.$emit("switchscreen", next);
        }
        if (this.screen == 'login') {
          this.$emit('loggedin');
        }
      } else {
        this.failed = true;
        this.errorName = resData.response.errorDetails.name;
      }
    },
  },
  watch: {
    screen() {
      this.failed = false;
      this.errorName = null;
      this.$nextTick(() => this.focusField());
    },
  },
});
</script>
